import { render, staticRenderFns } from "./CardCollapse.vue?vue&type=template&id=6058bda6&scoped=true&"
import script from "./CardCollapse.vue?vue&type=script&lang=js&"
export * from "./CardCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CardCollapse.vue?vue&type=style&index=0&id=6058bda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058bda6",
  null
  
)

export default component.exports